import { ChevronsUpDown } from 'lucide-react'
import type {
  CompanyTableSortColumnHeaderProps,
  CompanyTableSortIconProps,
} from '../types/components'
import { cn } from '@/lib/utils/helpers'
import styles from '@/features/invitee/styles/invitesParity.module.css'

export function CompanyTableSortIcon({
  field,
  orderBy,
  sortBy,
}: CompanyTableSortIconProps) {
  const isActive = orderBy === field
  return (
    <span
      aria-hidden="true"
      className={cn(styles.sortIcon, isActive && styles.sortIconActive)}
    >
      {isActive ? (sortBy === 'asc' ? '▲' : '▼') : <ChevronsUpDown className="h-3 w-3" />}
    </span>
  )
}

export function CompanyTableSortColumnHeader({
  field,
  orderBy,
  sortBy,
  onSort,
  children,
  className = '',
  align = 'start',
  disabled = false,
}: CompanyTableSortColumnHeaderProps) {
  return (
    <th
      data-testid={`company-list-sort-header-${field}`}
      className={cn(
        'select-none',
        disabled ? 'pointer-events-none cursor-not-allowed opacity-60' : 'cursor-pointer',
        align === 'center' && '!text-center',
        className,
      )}
      onClick={() => {
        if (!disabled) onSort(field)
      }}
    >
      <button
        type="button"
        disabled={disabled}
        className={cn(
          styles.sortHeaderButton,
          align === 'center' && 'w-full justify-center',
        )}
        onClick={(event) => {
          event.stopPropagation()
          if (!disabled) onSort(field)
        }}
      >
        <span className={styles.sortHeaderLabel}>{children}</span>
        <CompanyTableSortIcon field={field} orderBy={orderBy} sortBy={sortBy} />
      </button>
    </th>
  )
}
